import { useState } from "react";

import { Trans, useTranslation } from "react-i18next";

import { ApiResources } from "@/api/resources";
import InfoIconWithTooltip from "@/components/IconsWithTooltips/InfoIconWithTooltip/InfoIconWithTooltip";
import RectangleLoader from "@/shared/components/loaders/RectangleLoader";
import { useDashboardStore } from "@/stores/useDashboardStore";

import { ROUTES, useMediaQueries } from "../../../../../shared";
import CardWrapper from "../../../CardWrapper/CardWrapper";
import ChartWrapper from "../../../shared/ChartWrapper/ChartWrapper";
import DownloadStatus from "../DownloadStatus/DownloadStatus";
import useResourceDownloadsStatus from "../hooks/useResourceDownloadsStatus";

const VehicleDownloads = () => {
  const { t } = useTranslation();
  const { toSm, toMd } = useMediaQueries();

  const { isDashboardLoading, vehicleDownloadsError, vehicleDownloadsStatus } =
    useDashboardStore();

  const { isLoading: isVehicleDownloadsStatusLoading } =
    useResourceDownloadsStatus(ApiResources.DashboardVehicleDownloads);

  const [showBackButton, setShowBackButton] = useState<boolean>(false);
  const [backButton, setBackButton] = useState<Element | null>(null);

  const isLoading = isVehicleDownloadsStatusLoading || isDashboardLoading;

  return (
    <CardWrapper
      isDashboardDownloads={!toSm}
      cardTitle={t("Dashboard##vehicle downloads")}
      isError={vehicleDownloadsError}
      isInnerCard
      isLoading={isLoading}
      titleInlineAction={showBackButton && <>{backButton}</>}
      titleExtention={
        <InfoIconWithTooltip
          title={
            <Trans i18nKey="Dashboard##card tooltips##vehicle downloads" />
          }
          iconTestId="vehicle-downloads-info icon"
          tooltipSize="medium"
        />
      }
    >
      <ChartWrapper hasTabs={false}>
        {isLoading ? (
          <RectangleLoader
            width="100%"
            height="100%"
            customStyle={
              toMd && {
                minHeight: "252px"
              }
            }
            testId="vehicle-downloads-card-loader"
          />
        ) : (
          <DownloadStatus
            resourceDownloadLocation={ROUTES.Vehicles}
            isDownloadStatusLoading={isVehicleDownloadsStatusLoading}
            resourceDownloadStatus={vehicleDownloadsStatus}
            setShowBackButton={setShowBackButton}
            setBackButton={setBackButton}
          />
        )}
      </ChartWrapper>
    </CardWrapper>
  );
};

export default VehicleDownloads;
